<script setup lang="ts">
  import type { RoutedCustomerViewComponentProps } from '@/types';
  import useAsyncComponentLoader from '@/composables/useAsyncComponentLoader.ts';

  defineOptions({ name: 'HistoryFormView', inheritAttrs: false });

  defineProps<RoutedCustomerViewComponentProps>();

  const { getAsyncComponentWithLoader } = useAsyncComponentLoader();

  const HistoryFormController = getAsyncComponentWithLoader(() => import('@/components/historyPage/form/HistoryFormController.vue'));
</script>

<template>
  <HistoryFormController />
</template>
